class Brands {
    constructor() {

        this.brandHeader = document.querySelector('.brand-finder__header');
        this.brandList = document.querySelectorAll('.brand-finder__brand');

        if (!this.brandHeader) return;

        this.brandHeader.querySelectorAll('button').forEach((button) => {

            button.addEventListener('click', (e) => {

                e.preventDefault();

                let _val = button.id;
                let _valInt = parseInt(button.id);

                if (_val == 'all') {

                    this.brandList.forEach((br) => {

                        br.classList.remove('hidden');

                    });

                } else if (Number.isInteger(_valInt)) {

                    this.brandList.forEach((br) => {

                        let _id = parseInt(br.dataset.id);

                        if (Number.isInteger(_id) == false) {

                            br.classList.add('hidden');

                        } else {

                            br.classList.remove('hidden');

                        }

                    });

                } else {

                    this.brandList.forEach((br) => {
    
                        if (br.dataset.id != _val) {
    
                            br.classList.add('hidden');
    
                        } else {
    
                            br.classList.remove('hidden');
    
                        }
    
                    });

                }


            });

        });

    }
}

let _brands = new Brands();